import VideoSnapshot from "video-snapshot";
import { StorageItemFileTypes } from "@/views/academy/enums/StorageItemFileTypes";

export const prepareThumbnailFile = async (mediaFile: RequestInfo) => {
  const res = await fetch(mediaFile);
  const blob = await res.blob();
  const file = new File([blob], "thumbnail", {
    type: StorageItemFileTypes.JPEG
  });
  const formData = new FormData();
  formData.append("file", file);

  return formData;
};

export const getThumbnail = async (file: Blob) => {
  const snapshoter = new VideoSnapshot(file);
  const thumbnail = await snapshoter.takeSnapshot();
  return await prepareThumbnailFile(thumbnail);
};

export const getBase64Thumbnail = async (file: Blob) => {
  const snapshoter = new VideoSnapshot(file);
  return await snapshoter.takeSnapshot();
};
